import React from "react";
import { Typography, Card, CardBody } from "@material-tailwind/react";
import Image from "next/image";

interface BottleConditionsCardProps {
  img: string;
  client: string;
  alt: string;
}

export function BottleConditionsCard({
  img,
  client,
  alt,
}: BottleConditionsCardProps) {
  return (
    <Card {...({} as any)} shadow={false} className="items-center text-center bg-transparent">
      <CardBody {...({} as any)} className="!pt-2 !pb-2 !pl-1 !pr-1">
        {/* Container สำหรับภาพ: กำหนดตำแหน่ง relative, ขนาด, rounding และ overflow-hidden */}
        <div className="relative w-[16rem] h-[16rem] mx-auto mb-3 rounded-[20px] overflow-hidden">
          <Image
            src={img}
            alt={alt}
            fill
            loading="lazy"
            className="object-cover"
          />
        </div>

        <Typography
          {...({} as any)}
          as="p"
          variant="paragraph"
          color="blue-gray"
          className="font-semibold whitespace-pre-line tracking-wide"
        >
          {client}
        </Typography>
      </CardBody>
    </Card>
  );
}

export default BottleConditionsCard;
